module.exports = __webpack_public_path__ + "static/media/ProtonNet.37336559.png";